// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"37a55f9f","488":"ecbfdacb"}[chunkId] + ".chunk.js";
};